// extracted by mini-css-extract-plugin
export default {"pageInfo":"PageInfoV5_pageInfo__owv+t","header":"PageInfoV5_header__n250d","line":"PageInfoV5_line__hZtSm","textBox":"PageInfoV5_textBox__RDbBj","image":"PageInfoV5_image__8qHus"};